export default "__VITE_ASSET__C1d3YITH__"